export default {
    page: 1,
    pageSize: 25,
    // sort: {
    //     fieldName: 'id',
    //     ascending: true,
    // },
};
